// extracted by mini-css-extract-plugin
module.exports = {"buttonBox":"payment-button-box_buttonBox__2Pw0j","disabled":"payment-button-box_disabled__2RV_U"};